import { themeAtom } from "@src/jotai/theme";
import classNames from "classnames";
import { useAtomValue } from "jotai";
import { Trans } from "react-i18next";

interface ProgressBarProps {
  percent: number;
}
const ProgressBar: React.FC<ProgressBarProps> = ({ percent }) => {
  const isDark = useAtomValue(themeAtom) === "dark";
  return (
    <div>
      <div className="text-[#999] text-[14px] mx-[16px] mb-[10px]">
        <Trans>Optimization in progress. Please keep this tab open to avoid interruption.</Trans>
      </div>
      <div
        className={classNames(
          "h-[6px] rounded-full transition-all duration-300",
          isDark ? "kalo-bg-linear-gray" : "kalo-bg-linear-blue",
        )}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
};

export default ProgressBar;
